(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-story-video]').forEach(wrap => {
    const video = wrap.querySelector('video');
    if (!video) return;
    const sound = wrap.querySelector('[data-sound-toggle]');
    const toolbar = document.createElement('div');
    toolbar.className = 'story-video-controls';
    const play = document.createElement('button');
    play.type = 'button';
    play.setAttribute('data-play-toggle', '');
    toolbar.append(play);
    if (sound) {
      sound.type = 'button';
      sound.hidden = false;
      sound.removeAttribute('aria-pressed');
      toolbar.append(sound);
    }
    wrap.insertBefore(toolbar, video.nextSibling);
    video.controls = true;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.autoplay = false;
    video.removeAttribute('autoplay');

    let wanted = !reduced.matches;
    let userPaused = false;
    let visible = !('IntersectionObserver' in window);
    let systemPauses = 0;
    const labels = () => {
      play.textContent = video.paused ? 'Play video' : 'Pause video';
      if (sound) sound.textContent = video.muted ? 'Sound on' : 'Sound off';
    };
    const suspend = () => {
      if (!video.paused) {
        systemPauses += 1;
        video.pause();
      }
      labels();
    };
    const reconcile = () => {
      if (!visible || document.hidden || !wanted) return suspend();
      video.play().catch(labels);
    };
    play.addEventListener('click', () => {
      wanted = video.paused;
      userPaused = !wanted;
      reconcile();
    });
    if (sound) sound.addEventListener('click', () => {
      video.muted = !video.muted;
      labels();
    });
    video.addEventListener('volumechange', labels);
    video.addEventListener('play', () => {
      wanted = true;
      userPaused = false;
      labels();
    });
    video.addEventListener('pause', () => {
      if (systemPauses) systemPauses -= 1;
      else { wanted = false; userPaused = true; }
      labels();
    });
    reduced.addEventListener('change', () => {
      wanted = !reduced.matches && !userPaused;
      reconcile();
    });
    document.addEventListener('visibilitychange', reconcile);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .1);
        reconcile();
      }, {threshold: [0, .1]});
      observer.observe(video);
    }
    reconcile();
    labels();
  });
})();
